<template>
  <div>
    <panel title="Statusy">
      <w-table
        entity-type="status"
        :hide-search-input="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
        @buttons="openButtonsModal($event.id)"
        @editCriterion="editCriterion($event.id)"
      />
    </panel>

    <status-modal
      :id="idToEdit"
      :template-id="templateId"
      :show="showModal"
      @save="add"
      @close="hideModal"
      @update="update"
    />

    <buttons-modal :status-id="selectedStatusId" :show="showButtonsModal" @close="closeButtonsModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ButtonsModal from '@/components/modals/ButtonsModal';
import StatusModal from '@/components/modals/StatusModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { listMixin } from '@/mixins/list';
import { BUTTONS_ACTION, CRITERION_ACTION, DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania statusów.',
  getError: 'Wystąpił błąd podczas pobierania danych statusów.',
  added: 'Dodano status.',
  addError: 'Nie udało się dodać statusu.',
  updated: 'Zaktualizowano dane statusu.',
  updateError: 'Nie udało się zaktualizować danych statusu.',
  deleteConfirm: 'Czy na pewno chcesz usunąć statusu?',
  deleted: 'Usunięto status.',
  deleteError: 'Nie udało się usunąć statusu.'
};

// @vuese
// Lista Statusów
// @group Template
export default {
  components: { ButtonsModal, Panel, StatusModal, WTable },
  mixins: [listMixin('status', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true },
      { name: 'type', displayName: 'Typ' }
    ],
    actions: [BUTTONS_ACTION, CRITERION_ACTION, ...DEFAULT_TABLE_ACTIONS],
    showButtonsModal: false,
    selectedStatusId: undefined
  }),
  computed: {
    templateId() {
      return parseInt(this.$route.params.templateId);
    }
  },
  methods: {
    // @vuese
    // Otwiera modal z przycziskami
    openButtonsModal(statusId) {
      this.$store
        .dispatch('button/list', { statusId, count: -1 })
        .then(buttons => {
          this.showButtonsModal = true;
          this.selectedStatusId = statusId;
        })
        .catch(err => this.notifyError(Errors.BUTTON_CANNOT_LIST));
    },
    // @vuese
    // Zamyka modal z przyciskami
    closeButtonsModal() {
      this.showButtonsModal = false;
    },
    // @vuese
    // Przeniesienie na stronę edycji kryteriów etapu
    editCriterion(statusId) {
      this.$router.push({ name: 'statusCriterionList', params: { statusId } });
    }
  }
};
</script>
